import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Tooltip as Tooltip$1, tooltipClasses, ClickAwayListener } from '@mui/material';
import { styled } from '@mui/material/styles';
import { forwardRef, useState } from 'react';
import { shouldNotForwardProps, palette, spacing } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2;
const Container = styled( /*#__PURE__*/forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(Tooltip$1, Object.assign({
    ref: ref
  }, props, {
    classes: {
      popper: className
    }
  }));
}), {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  .${0} {
    background-color: ${0};
    color: ${0};
    font-weight: 500;
    font-size: 16px;
    border-radius: ${0};
  }

  .${0} {
    color: ${0};
  }
`), tooltipClasses.tooltip, palette('onSurfaceVariant'), palette('surfaceVariant'), spacing(2), tooltipClasses.arrow, palette('onSurfaceVariant'));
const Content = styled('div')(_t2 || (_t2 = _`
  display: inline;
  writing-mode: vertical-lr;
`));
const Tooltip = props => {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);
  return props.trigger === 'hover' ? jsx(Container, Object.assign({}, props)) : jsx(ClickAwayListener, Object.assign({
    onClickAway: handleClose
  }, {
    children: jsx(Container, Object.assign({}, props, {
      onClose: handleClose,
      open: open,
      disableFocusListener: true,
      disableHoverListener: true,
      disableTouchListener: true
    }, {
      children: jsx(Content, Object.assign({
        onClick: handleOpen
      }, {
        children: props.children
      }))
    }))
  }));
};

export { Tooltip };
